import { IconProps } from "./IconProps";
import { svgIconProps } from "./svgIconProps";

export function IconStar(props: IconProps) {
  return (
    <svg {...svgIconProps(props)}>
      <path d="M22.425 9.12a1.5 1.5 0 0 0-1.295-1.03l-5.567-.48-2.183-5.19a1.495 1.495 0 0 0-2.76 0L8.444 7.61l-5.574.482a1.5 1.5 0 0 0-.854 2.631l4.229 3.696-1.268 5.488a1.5 1.5 0 0 0 2.235 1.625l4.781-2.906 4.792 2.906a1.5 1.5 0 0 0 2.235-1.625l-1.267-5.494 4.229-3.69a1.5 1.5 0 0 0 .443-1.602Zm-1.427.47-4.228 3.69a1.5 1.5 0 0 0-.476 1.473l1.27 5.497-4.788-2.906a1.491 1.491 0 0 0-1.55 0L6.444 20.25l1.262-5.494a1.5 1.5 0 0 0-.476-1.473L3 9.595v-.008l5.573-.482a1.5 1.5 0 0 0 1.251-.914L12 3.007l2.175 5.184a1.5 1.5 0 0 0 1.252.914L21 9.587v.006l-.002-.003Z" />
    </svg>
  );
}
